import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import baseurl from '../@core/auth/jwt/baseurl'

export const getConfig = createAsyncThunk('configh/getconifg', async () => {
  const res = await baseurl.get('api/abp/application-configuration')

  return res.data
})

export const ConfigSlice = createSlice({
  name: 'appconfig',
  initialState: {
    config: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConfig.fulfilled, (state, action) => {
      if (action.payload?.currentUser?.id) {
        localStorage.setItem('application-configuration', JSON.stringify(action.payload))
        state.config = action.payload
      } else {
        const oldConfig = JSON.parse(localStorage.getItem('application-configuration'))
        state.config = oldConfig
      }
    })
  }
})

export default ConfigSlice.reducer
